var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageSample = function SvgImageSample(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg1",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "rotate(-45.97 11.021 29.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "m0 0 15.9 4.9L32 0l-3.7 16L32 32l-16-5.4L0 32l3.5-16Z",
    transform: "rotate(45 10.343 29.657)"
  }))));
};
export { SvgImageSample as ReactComponent };
export default __webpack_public_path__ + "assets/ImageSample.c3627199351c9a498ce15960f0de7866.svg";